import { Routes } from '@angular/router';
import { authCognitoGuard } from 'src/app/auth/auth-cognito.guard';
import { UsersListComponent } from './users-list/users-list.component';

/** Standalone routes for org user management. */
export const usersRoutes: Routes = [
  {
    path: 'users',
    pathMatch: 'full',
    component: UsersListComponent,
    canActivate: [authCognitoGuard],
  },
];
